import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.contents = this.el.querySelectorAll('.articleContent')
    this.btn = this.el.querySelector('.articleBtn')

    this.initEventListeners()
  }

  initEventListeners() {
    this.btn.addEventListener('click', () => {
      this.contents.forEach((content) => {
        content.classList.remove('hidden')
      })
      this.btn.classList.add('hidden')
    })
  }
}
